export enum ApplicationTypeAL {
	Undefined = 0,
    PSA = 1,
    CSP = 2,
    Accounting = 3,
    Other = 4,
}
